import { IconBase } from "./iconBase.js";
import { jsx } from "@emotion/react/jsx-runtime";
//#region src/thumbsUp.tsx
var ThumbsUp = ({ type, ...rest }) => /* @__PURE__ */ jsx(IconBase, {
	viewBox: "0 0 24 24",
	...rest,
	children: type === "stroke" ? /* @__PURE__ */ jsx("path", {
		d: "M6.74793 11.25H3.74948C3.19748 11.25 2.75 11.6977 2.75 12.25V19.75C2.75 20.3023 3.19748 20.75 3.74948 20.75H6.74793M6.74793 20.75V11.5L10.7166 3.79207C10.888 3.45921 11.2321 3.25003 11.6064 3.25003C12.8331 3.25003 13.7751 4.34539 13.5861 5.55814L13.0108 9.25003H18.2509C20.0866 9.25003 21.4914 10.8856 21.2152 12.7014L20.3787 18.2014C20.1558 19.6671 18.8962 20.75 17.4144 20.75H6.74793Z",
		stroke: "currentColor",
		strokeWidth: "1.5",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}) : /* @__PURE__ */ jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M11.6014 2.50003C10.9475 2.50003 10.3456 2.86518 10.0452 3.44861L6.41445 10.5H3.74427C2.77824 10.5 1.99512 11.2835 1.99512 12.25V19.75C1.99512 20.7165 2.77824 21.5 3.74427 21.5H17.4096C19.2619 21.5 20.8365 20.1463 21.1151 18.3142L21.9517 12.8142C22.2969 10.5445 20.5409 8.50003 18.2462 8.50003H13.8815L14.3219 5.67367C14.5822 4.00374 13.2858 2.50003 11.6014 2.50003ZM5.99317 12V20H3.74427C3.60626 20 3.49439 19.8881 3.49439 19.75V12.25C3.49439 12.112 3.60626 12 3.74427 12H5.99317Z",
		fill: "currentColor"
	})
});
//#endregion
export { ThumbsUp };
